<template>
  <div class="siteDisposal">
    <el-descriptions class="margin-top" size="medium" :column="1" border
                     :labelStyle="{'text-align': 'center','width':'30%','color':'#555'}">
      <el-descriptions-item label="更新地点（线路）">
        {{ formValidate.siteLine }}
      </el-descriptions-item>
      <el-descriptions-item label="更新地点（桩号）">
        {{ formValidate.sitePositionNum }}
      </el-descriptions-item>
      <el-descriptions-item label="处置前现场情况">
        {{ formValidate.eventSiteBefore }}
      </el-descriptions-item>
      <el-descriptions-item label="处置前现场情况图片">
        <!--        {{ formValidate.eventSiteBeforeImg }}-->
        <div style="display: flex;flex-direction: row;flex-wrap: wrap;align-content: flex-start;">
          <!--          <img v-for="(item,index) in formValidate.eventSiteBeforeImg" :src="item.url" :key="index" width="200" height="200" style="margin-right: 10px" @click="previewPic(item)"/>-->
          <el-image v-for="(item,index) in formValidate.eventSiteBeforeImg" :key="index"
                    style="width: 200px; height: 200px;margin-top: 10px;margin-right: 10px;"
                    :src="item"
                    :preview-src-list="formValidate.eventSiteBeforeImg">
          </el-image>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="处置后现场情况">
        {{ formValidate.eventSiteAfter }}
      </el-descriptions-item>
      <el-descriptions-item label="处置后现场情况图片">
        <!--        {{ formValidate.eventSiteAfterImg }}-->
        <div style="display: flex;flex-direction: row;flex-wrap: wrap;align-content: flex-start;">
          <!--          <img v-for="(item,index) in formValidate.eventSiteAfterImg" :src="item.url" :key="index" width="200" height="200" style="margin-right: 10px" @click="previewPic(item)"/>-->
          <el-image v-for="(item,index) in formValidate.eventSiteAfterImg" :key="index"
                    style="width: 200px; height: 200px;margin-top: 10px;margin-right: 10px;"
                    :src="item"
                    :preview-src-list="formValidate.eventSiteAfterImg">
          </el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <!--    <div style="text-align: center">-->
    <!--      <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>-->
    <!--    </div>-->

    <Modal
        v-model="showPic"
        title="预览"
        :footer-hide="true"
    >
      <img :src="selectPic.url" width="100%" height="100%"/>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "siteDisposal",
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPic: false,
      selectPic: {},
      formValidate: {
        siteLine: '',
        sitePositionNum: '',
        eventSite: '',
        eventSiteBefore: '',
        eventSiteBeforeImg: '',
        eventSiteAfter: '',
        eventSiteAfterImg: ''
      }
    }
  },
  mounted() {
    if (this.stepInfo !== '' && this.stepInfo !== null) {
      this.formatInfo()
    }
  },
  methods: {
    previewPic(item) {
      this.showPic = true
      this.selectPic = item
    },
    formatInfo() {
      let info = this.stepInfo.split(';')
      // console.log(info)
      info.forEach(item => {
        const obj = item.split('_')
        // console.log(obj)
        this.formValidate[obj[0]] = obj[1]
        if (obj[0] === 'eventSiteBeforeImg') {
          if (obj[1] === '[]') {
            this.formValidate.eventSiteBeforeImg = list
          } else {
            let str = ''
            for (let i = 1; i <= obj.length - 1; i++) {
              str = str + obj[i]
            }
            let list = JSON.parse(str)
            list = list.map(item => {
              return item.url
            })
            this.formValidate.eventSiteBeforeImg = list
          }
        }
        if (obj[0] === 'eventSiteAfterImg') {
          if (obj[1] === '[]') {
            this.formValidate.eventSiteAfterImg = []
          } else {
            let str = ''
            for (let i = 1; i <= obj.length - 1; i++) {
              str = str + obj[i]
            }
            let list = JSON.parse(str)
            list = list.map(item => {
              return item.url
            })
            this.formValidate.eventSiteAfterImg = list
          }
        }
      })
    },
    handleSubmit(name) {
      // this.$Message.success('Success!');
      let params = {
        currentLink: this.eventInfo.currentLink,
        indexCode: this.eventInfo.deptIndexCode,
        information: `siteLine_${this.siteLine};sitePositionNum_${this.sitePositionNum};eventSite_${this.formValidate.eventSite};eventSiteBefore_${this.formValidate.eventSiteBefore};eventSiteBeforeImg_${this.formValidate.eventSiteBeforeImg};eventSiteIng_${this.formValidate.eventSiteIng};eventSiteIngImg_${this.formValidate.eventSiteIngImg};eventSiteAfter_${this.formValidate.eventSiteAfter};eventSiteAfterImg_${this.formValidate.eventSiteAfterImg};`,
        messageId: this.eventInfo.id
      }
      // console.log(params)
      this.$http.post('/api/jumpNextLink', params).then(res => {
        console.log(res)
        this.$emit('refreshStep')
      })
    }
  }
}
</script>

<style scoped lang="less">
.siteDisposal {
  width: 60%;
  margin: 0 auto;
}
</style>
